// const ApiName = 'http://192.168.20.97:9999';
const ApiName = 'https://api-id.tdtu.uz';

export {ApiName}